module.exports = __webpack_public_path__ + "static/jennison-21239470f3f382af61dff5f96c714507.jpg";